module.exports = __webpack_public_path__ + "img/banner.b34300d5.webp";